import React, { useState } from "react";
import { Mail, ArrowRight } from "lucide-react";
import { useToast } from "../hooks/use-toast";
import { postContact } from "../api";
import { useI18n } from "../i18n/I18nContext";

const inputCls =
  "w-full bg-white border border-slate-300 rounded-lg px-4 py-3 text-[15px] text-[#0a2540] placeholder:text-slate-400 outline-none focus:border-[#0a6ed1] focus:ring-2 focus:ring-[#0a6ed1]/20 transition";

const Contact = () => {
  const { toast } = useToast();
  const { t } = useI18n();
  const [form, setForm] = useState({ name: "", email: "", company: "", interest: "", message: "" });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast({ title: t("contactReqTitle"), description: t("contactReqBody") });
      return;
    }
    try {
      await postContact(form);
      toast({ title: t("contactOkTitle"), description: t("contactOkBody") });
      setForm({ name: "", email: "", company: "", interest: "", message: "" });
    } catch (err) {
      toast({ title: t("contactErrTitle"), description: t("contactErrBody") });
    }
  };

  return (
    <div>
      <section className="bg-[#0a2540] text-white py-20 md:py-28">
        <div className="max-w-[1400px] mx-auto px-5 md:px-8">
          <span className="text-sm font-700 uppercase tracking-widest text-[#5eb0f5]">
            {t("contact")}
          </span>
          <h1 className="font-display font-800 text-4xl md:text-6xl mt-3 max-w-3xl leading-[1.05]">
            {t("contactTitle")}
          </h1>
          <p className="mt-6 text-slate-300 text-lg max-w-2xl">
            {t("contactBody")}
          </p>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-5 md:px-8 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">
          {/* Form */}
          <div className="lg:col-span-7">
            <form onSubmit={handleSubmit} className="space-y-5">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label className="block text-sm font-600 text-[#0a2540] mb-2">{t("fullName")} *</label>
                  <input name="name" value={form.name} onChange={handleChange} placeholder={t("namePlaceholder")} className={inputCls} />
                </div>
                <div>
                  <label className="block text-sm font-600 text-[#0a2540] mb-2">{t("workEmail")} *</label>
                  <input name="email" type="email" value={form.email} onChange={handleChange} placeholder={t("emailPlaceholder2")} className={inputCls} />
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label className="block text-sm font-600 text-[#0a2540] mb-2">{t("companyLabel")}</label>
                  <input name="company" value={form.company} onChange={handleChange} placeholder={t("companyPlaceholder")} className={inputCls} />
                </div>
                <div>
                  <label className="block text-sm font-600 text-[#0a2540] mb-2">{t("areaOfInterest")}</label>
                  <input name="interest" value={form.interest} onChange={handleChange} placeholder={t("interestPlaceholder")} className={inputCls} />
                </div>
              </div>
              <div>
                <label className="block text-sm font-600 text-[#0a2540] mb-2">{t("howCanWeHelp")} *</label>
                <textarea name="message" value={form.message} onChange={handleChange} rows={5} placeholder={t("messagePlaceholder")} className={inputCls} />
              </div>
              <button type="submit" className="inline-flex items-center gap-2 bg-[#0a2540] hover:bg-[#16355c] text-white font-600 px-8 py-3.5 rounded-full transition-colors">
                {t("sendMessage")} <ArrowRight className="w-4 h-4" />
              </button>
            </form>
          </div>

          {/* Contact info */}
          <div className="lg:col-span-5">
            <div className="bg-slate-50 rounded-2xl p-8">
              <h3 className="font-display font-700 text-xl text-[#0a2540] mb-6">{t("getInTouchTitle")}</h3>
              <div className="space-y-4">
                <a href="mailto:info@b-p-c.net" className="flex items-center gap-3 text-slate-600 hover:text-[#0a6ed1] transition-colors">
                  <span className="flex items-center justify-center w-10 h-10 rounded-full bg-[#0a6ed1]/10"><Mail className="w-5 h-5 text-[#0a6ed1]" /></span>
                  info@b-p-c.net
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
